export const CTRL_RECORDVIEW = 'recordview';
export const CTRL_INDEX = 'index';
export const CTRL_EXPORT = 'export';
export const CTRL_LOGIN = 'login';
export const CTRL_ELEMENT = 'element';
export const CTRL_VERSION = 'version';
export const CTRL_TASK = 'task';
export const CTRL_IMPORT = 'import';
export const CTRL_USERINFO = 'userinfo';
export const CTRL_UPDATE = 'update';
export const CTRL_ROLE = 'role';
export const CTRL_USER = 'user';
export const CTRL_NOTICE = 'notice';
export const CTRL_REMOVESEL = 'removesel';
export const CTRL_DUMP_INSTITUTION = 'dumpInstitution';
export const portraitDefault = '/front/assets/userinfo/portrait_default.png';
